import { colors, IconBell } from '@cabonline/ui-shared';
import { useLocale } from '@multiplatform-apps/service-trips';
import { FC, useCallback } from 'react';

import { NotificationPopover } from './notification-popover';
import {
  StyledBadge,
  StyledBellButton,
  StyledBellWrapper,
} from './styles';
import { useNotificationBell } from './use-notification-bell';

export interface NotificationBellProps {
  onAcknowledge?: () => void;
}

export const NotificationBell: FC<NotificationBellProps> = ({
  onAcknowledge,
}) => {
  const { t } = useLocale();
  const {
    isOpen,
    shakeKey,
    totalUnread,
    categories,
    hasNew,
    wrapperRef,
    buttonRef,
    popoverRef,
    handleToggle,
    handleClose,
  } = useNotificationBell();

  const handleViewAll = useCallback(() => {
    onAcknowledge?.();
  }, [onAcknowledge]);

  return (
    <StyledBellWrapper ref={wrapperRef}>
      <StyledBellButton
        ref={buttonRef}
        key={shakeKey}
        hasNew={hasNew}
        onClick={handleToggle}
        aria-label={t('navBar.notifications')}
        aria-haspopup="dialog"
        aria-expanded={isOpen}
      >
        <IconBell width={24} height={24} color={colors.primary} />
        {totalUnread > 0 && (
          <StyledBadge aria-label={`${totalUnread} ${t('navBar.notifications')}`}>
            {totalUnread > 99 ? '99+' : totalUnread}
          </StyledBadge>
        )}
      </StyledBellButton>
      {isOpen && (
        <NotificationPopover
          ref={popoverRef}
          categories={categories}
          onClose={handleClose}
          onViewAll={handleViewAll}
        />
      )}
    </StyledBellWrapper>
  );
};

NotificationBell.displayName = 'NotificationBell';
